import { apiGet, apiPut } from "../client";
import type {
  SystemTerminologyConfigurationApi,
  UpdateSystemTerminologyConfigurationRequest,
} from "../models/systemTerminologyConfiguration";

export async function getSystemTerminologyConfiguration(): Promise<SystemTerminologyConfigurationApi> {
  return apiGet<SystemTerminologyConfigurationApi>("system/terminology");
}

export async function updateSystemTerminologyConfiguration(
  request: UpdateSystemTerminologyConfigurationRequest,
): Promise<SystemTerminologyConfigurationApi> {
  return apiPut<SystemTerminologyConfigurationApi>(
    "system/terminology",
    request,
  );
}
